export default {
  id: 140,
  title: 'Target #140 - Eclipse',
  url: 'https://cssbattle.dev/play/140',
  colors: ['#4F77FF', '#1038BF', '#FFFFFF'],
  solution:
    '<a a><a b><style>body{background:#4f77ff}a{position:fixed}[a]{top:90;left:160;width:80;height:80;border-radius:9in;box-shadow:0 -40px #fff}[b]{top:190;left:75;width:250;height:250;background:#1038bf;transform:rotate(45deg)}</style>',
}
